import React from "react";
import { Grid, Container } from "semantic-ui-react";
import { actions, resources } from "../../shared/Literals";

import Can from "../../accessControls/Can";
import { Redirect } from "react-router";
import MediaLayout from "../../layouts/MediaLayout";
// import EsvdUploadDataset from "./EsvdUploadDataset";
import EsvdUploadDataset from "./EsvdUploadDataset";
import { VslGridHubProvider } from "../../providers/VslGridHubProvider";

const { Media, MediaContextProvider } = MediaLayout;

const UploadDatasetBoard = (props: any) => {
	const renderContent = () => {
		return (
			<VslGridHubProvider>
				<MediaContextProvider>
					<Media at="mobile">
						{/* <FilterQueryButton /> */}
						<EsvdUploadDataset />
					</Media>
					<Media greaterThan="mobile">
						<Container className="top-container">
							<Grid columns={2} className="page-content" stackable>
								<Grid.Row>
									<Grid.Column width={16} stretched>
										<EsvdUploadDataset />
									</Grid.Column>
								</Grid.Row>
							</Grid>
						</Container>
					</Media>
				</MediaContextProvider>
			</VslGridHubProvider>
		);
	};
	return (
		<Can
			action={actions.read}
			resource={resources.uploads.name}
			yes={() => renderContent()}
			no={() => <Redirect to={"/"} />}
		/>
	);
};

export default UploadDatasetBoard;
